<!-- <template>
  <div class="build">
    <control />
  </div>
</template>

<script>
import Control from "@/components/Control";

export default {
  components: {
    Control,
  },
};
</script>
<style lang="scss" scoped>
.build {
  height: 100vh;
  background: #f7f8fa;
  }
</style> -->


<template>
  <div class="build">
    <template v-if="dataLoaded">
      <template v-if="hasSites || !isSubAccount">
        <control />
      </template>
      <div v-else class="empty-build-guide">
        <i class="el-icon-office-building empty-build-icon"></i>
        <h3>暂无微站</h3>
        <p>您还没有创建微站，请先前往微站管理创建微站</p>
        <el-button type="primary" @click="goToPagesManage">
          <i class="el-icon-plus"></i> 去创建微站
        </el-button>
      </div>
    </template>
    <div v-else class="loading-container">
      <!-- We will use Loading service instead of el-loading component -->
    </div>
  </div>
</template>

<script>
import Control from "@/components/Control";
import { getProjectById } from "@/api/project";
import { mapGetters, mapMutations } from "vuex";
import request from "@/utils/request";
// Import Loading service from Element UI
import { Loading } from "element-ui";

export default {
  components: {
    Control,
  },
  data() {
    return {
      dataLoaded: false,
      loadingInstance: null,
      hasSites: true
    };
  },
  computed: {
    ...mapGetters(["project", "curPage", "userInfo"]),
    isSubAccount() {
      return this.userInfo && this.userInfo.isSubAccount
    }
  },
  methods: {
    ...mapMutations(["setProject", "setCurPage"]),

    goToPagesManage() {
      this.$router.push({ path: '/mall/pages-manage' });
    },

    async fetchLatestData(authorizedSiteIds = null) {
      try {
        // 先从 Vuex 获取当前页面 ID
        const pageId = this.curPage?.id;
        // 获取项目 ID
        const projectId = this.project?._id;

        if (!projectId) {
          console.error("项目ID不存在，无法获取数据");
          this.dataLoaded = true;
          return;
        }

        // 从服务器获取最新项目数据
        const { data } = await getProjectById({ id: projectId });

        if (data && data.pages) {
          // 更新整个项目数据到 Vuex
          this.setProject(data);

          // 子账号：优先使用授权站点的页面
          if (authorizedSiteIds && authorizedSiteIds.length > 0) {
            // 找到第一个有授权站点页面
            const authorizedPage = data.pages.find(page => {
              return page.site && authorizedSiteIds.includes(page.site);
            });
            if (authorizedPage) {
              this.setCurPage(authorizedPage);
              if (this.loadingInstance) {
                this.loadingInstance.close();
              }
              this.dataLoaded = true;
              return;
            }
          }

          // 非子账号或没有授权站点，走原来的逻辑
          // 根据页面 ID 找到对应的页面
          const currentPage = data.pages.find(page => page.id === pageId);
          
          if (currentPage) {
            // 更新当前页面到 Vuex
            this.setCurPage(currentPage);
          } else {
            console.error("无法找到当前页面，使用项目首页");
            // 找不到页面时使用首页
            const homePage = data.pages.find(page => page.home);
            if (homePage) {
              this.setCurPage(homePage);
            }
          }
        }
      } catch (error) {
        console.error("获取最新数据失败:", error);
        this.$message.error("获取最新数据失败，将使用本地缓存的数据");
      } finally {
        this.dataLoaded = true;
        // 关闭加载中动画
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
      }
    }
  },
  created() {
    // 先启动加载动画
    this.loadingInstance = Loading.service({
      fullscreen: true,
      text: "正在获取最新数据...",
      background: "rgba(255, 255, 255, 0.7)"
    });

    // 子账号先检查站点
    if (this.isSubAccount) {
      request({ url: '/site/list', method: 'GET' }).then(siteRes => {
        this.hasSites = siteRes.status == "10000" && siteRes.data && siteRes.data.length > 0;
        this.dataLoaded = true;
        if (this.hasSites) {
          // 将子账号授权的站点ID传给 fetchLatestData
          const authorizedSiteIds = siteRes.data.map(s => s._id);
          this.fetchLatestData(authorizedSiteIds);
        } else {
          // 无站点，直接关闭加载动画
          if (this.loadingInstance) {
            this.loadingInstance.close();
          }
        }
      }).catch(() => {
        this.dataLoaded = true;
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
      });
    } else {
      this.fetchLatestData();
    }
  },
  mounted() {
    // loading已在created中启动，mounted中无需再创建
  },
  beforeDestroy() {
    // 组件销毁前关闭 loading
    if (this.loadingInstance) {
      this.loadingInstance.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.build {
  height: 100vh;
  background: #f7f8fa;
}
.loading-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-build-guide {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background: #f7f8fa;

  .empty-build-icon {
    font-size: 64px;
    color: #dcdfe6;
    margin-bottom: 16px;
  }

  h3 {
    font-size: 18px;
    color: #303133;
    margin: 0 0 8px;
  }

  p {
    font-size: 14px;
    color: #909399;
    margin: 0 0 24px;
  }
}
</style>